import { render, staticRenderFns } from "./SelectVcs.vue?vue&type=template&id=66f90545&"
import script from "./SelectVcs.vue?vue&type=script&lang=js&"
export * from "./SelectVcs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports